import { TabGroup, TabIndex } from '../enums/tab.enum';

export class FilterAction {
  constructor(public action: any, public tabGroup: TabGroup, public tabIndex?: TabIndex) {}
}
